var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 5.49927V3.49927C13.4997 2.94698 13.052 2.49927 12.4997 2.49927H9.83301",
    stroke: "#229892",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 2.49927H1.5C0.947715 2.49927 0.5 2.94698 0.5 3.49927V14.4993C0.5 15.0516 0.947715 15.4993 1.5 15.4993H5.5",
    stroke: "#229892",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61391 3.15727C9.54568 3.36147 9.35454 3.49919 9.13924 3.49927H4.86058C4.64528 3.49919 4.45414 3.36147 4.38591 3.15727L3.71924 1.15727C3.66813 1.00474 3.69362 0.836932 3.78773 0.706471C3.88185 0.57601 4.03305 0.498878 4.19391 0.499269H9.80591C9.96677 0.498878 10.118 0.57601 10.2121 0.706471C10.3062 0.836932 10.3317 1.00474 10.2806 1.15727L9.61391 3.15727Z",
    stroke: "#229892",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8.49927C7.5 7.94698 7.94772 7.49927 8.5 7.49927H14.5C15.0523 7.49927 15.5 7.94698 15.5 8.49927V14.4993C15.5 15.0516 15.0523 15.4993 14.5 15.4993H8.5C7.94772 15.4993 7.5 15.0516 7.5 14.4993V8.49927Z",
    stroke: "#229892",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.49927H13.5",
    stroke: "#229892",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.4993H13.5",
    stroke: "#229892",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.4993H11",
    stroke: "#229892",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.387f7c31.svg";
export { ForwardRef as ReactComponent };